import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { withRouter } from "react-router";
import {
	IonApp,
	IonIcon,
	IonLabel,
	IonRouterOutlet,
	IonTabBar,
	IonTabButton,
	IonTabs,
	setupIonicReact
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { listOutline, peopleOutline, cog } from 'ionicons/icons';
import Settings from './pages/Settings';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import Titlescreen from './pages/Titlescreen';
import "primereact/resources/themes/lara-light-indigo/theme.css";  //theme
import "primereact/resources/primereact.min.css";                  //core css
import "primeicons/primeicons.css";
import WishList from './pages/WishList';
import Friends from './pages/Friends';
import { useState } from 'react';
import { GetResult, Storage } from '@capacitor/storage';
import Search from './pages/Search';
import ToastController from './components/ToastController';
import DialogController from './components/DialogController';
import { HTTP } from '@awesome-cordova-plugins/http';
import Offline from './pages/Offline';

setupIonicReact();


export class LoggedInApp extends React.Component<any, any> {

	private static instance: LoggedInApp;

	constructor(props: any) {
		super(props);
		LoggedInApp.instance = this;
	}

	public static inTabbedView(): boolean {
		return LoggedInApp.instance.inView();
	}

	public static goToOfflinePage(): void {
		if(LoggedInApp.instance)
		{
			LoggedInApp.instance.props.history.push("/app/offline");
		}
	}

	public inView(): boolean {
		return this.props.location.pathname.includes('app/');
	}

	render() {
		return (
		<IonTabs>
			<IonRouterOutlet>
				<Route exact path="/app/user">
					<WishList />
				</Route>
				<Route exact path="/app/tab1">
					<WishList me />
				</Route>
				<Route exact path="/app/user">
					<WishList />
				</Route>
				<Route exact path="/app/tab2">
					<Friends />
				</Route>
				<Route path="/app/tab3">
					<Settings />
				</Route>
				<Route path="/app/offline">
					<Offline />
				</Route>
				<Route exact path="/app">
					<Redirect to="/app/tab1" />
				</Route>
			</IonRouterOutlet>
			<IonTabBar slot="bottom">
				<IonTabButton tab="tab1" href="/app/tab1">
					<IonIcon icon={listOutline} />
					<IonLabel>Din Ønskeliste</IonLabel>
				</IonTabButton>
				<IonTabButton tab="tab2" href="/app/tab2">
					<IonIcon icon={peopleOutline} />
					<IonLabel>Venner</IonLabel>
				</IonTabButton>
				<IonTabButton tab="tab3" href="/app/tab3">
					<IonIcon icon={cog} />
					<IonLabel>Indstillinger</IonLabel>
				</IonTabButton>
			</IonTabBar>
		</IonTabs>
		)
	}


}

const LoggedInAppWithRouter = withRouter(LoggedInApp); 

const App: React.FC = () => (
	<IonApp>
		<IonReactRouter>
			<IonRouterOutlet>
				<Route path="/app">
					<LoggedInAppWithRouter />
				</Route>
				<Route path="/search">
					<Search />
				</Route>
				<Route path="/list">
					<WishList spot />
				</Route>
				<Route exact path="/">
					<Titlescreen />
				</Route>
			</IonRouterOutlet>
		</IonReactRouter>
		<ToastController />
		<DialogController />
	</IonApp>
);

export default App;
